module.exports = __webpack_public_path__ + "img/741502a.jpg";